import { List, ListItem, Stack, Typography } from '@mui/joy';
import { graphql, useStaticQuery } from 'gatsby';
import type { FC } from 'react';
import React from 'react';
import Link from './Link';

export interface RecentProps {}

const Recent: FC<RecentProps> = () => {
  const data = useStaticQuery<Queries.RecentQuery>(graphql`
    query Recent {
      articles: allMdx(
        sort: { frontmatter: { created: DESC } }
        filter: { fields: { slug: { regex: "/writing/" } } }
      ) {
        nodes {
          id
          fields {
            slug
          }
          frontmatter {
            title
            created(formatString: "YYYY-MM-DD")
          }
        }
      }
    }
  `);

  return (
    <List component="ul" sx={{ padding: 0 }}>
      {data.articles.nodes.map((n) => (
        <ListItem sx={{ padding: 0 }}>
          <Stack direction="row" gap={1}>
            <Typography>{n.frontmatter.created}</Typography>
            <Link to={n.fields?.slug!} underline="always">
              {n.frontmatter.title}
            </Link>
          </Stack>
        </ListItem>
      ))}
    </List>
  );
};

export default Recent;
